import PaymentsSvc from '@efex-services/payments';
import { IEnterprisePayment } from '@efex-services/payments/types';
import { useApiCall } from '@efexteam/use-api-call';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useTransferDetails = ({ transferId }: { transferId: string }) => {
  const userProfile = useSelector(selectProfileData);
  const [transfer, setTransfer] = useState<IEnterprisePayment | null>(null);

  const { enterpriseId } = userProfile?.company || {};

  const {
    data,
    loading,
    invoke: getPayments,
  } = useApiCall(() => {
    if (!enterpriseId) {
      throw new Error('Enterprise ID is required');
    }
    return PaymentsSvc.getPayments({
      enterpriseId: Number(enterpriseId),
    });
  });

  useEffect(() => {
    getPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferId]);

  useEffect(() => {
    if (data) {
      setTransfer(
        data.results.find((movement) => movement.uuid === transferId) || null
      );
    }
  }, [data, transferId]);

  return { transfer, loading, getPayments };
};

export default useTransferDetails;
